"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUBBLE_ARROW_OFFSET_Y = exports.BUBBLE_ARROW_OFFSET_X = exports.HIDE_DELAY_DEFAULT = exports.SHOW_DELAY_DEFAULT = void 0;
// (C) 2019 GoodData Corporation
exports.SHOW_DELAY_DEFAULT = 200;
exports.HIDE_DELAY_DEFAULT = 0;
exports.BUBBLE_ARROW_OFFSET_X = 0;
exports.BUBBLE_ARROW_OFFSET_Y = -37;
//# sourceMappingURL=bubble.js.map